<template>
  <div class="AssignmentTask assignment-task">
    <v-card-title class="assignment-task__question">
      <div class="mr-4">
        <div class="text-body-1">
          {{ AssignmentTaskTitle[task.type] }}
        </div>
        <div class="font-weight-bold font-italic">
          {{ task.question }}
        </div>
      </div>
      <v-spacer />
      <template v-if="typeof task.points === 'number'">
        <v-chip
          v-if="report"
          color="white"
        >
          {{ taskPoints }} points
        </v-chip>
        <v-avatar
          v-else
          color="white"
        >
          <span class="font-weight-bold">{{ task.points }}</span>
        </v-avatar>
      </template>
    </v-card-title>

    <v-card-text>
      <v-textarea
        v-if="task.type === AssignmentTaskType.FillInTheBlanks"
        v-model="specifiedAnswer"
        placeholder="Write your answer..."
        outlined
        solo
      />
      <v-list
        v-else
        outlined
        subheader
      >
        <v-subheader class="text-uppercase">{{ AssignmentTaskTitle[task.type] }}</v-subheader>
        <v-list-item-group
          v-model="specifiedAnswer"
          :multiple="multipleAnswers"
          color="blue"
        >
          <v-list-item
            v-for="option in task.options"
            :key="option.id"
            :ripple="false"
            :disabled="!!report"
            selectable
          >
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox :input-value="active" :disabled="!!report" />
              </v-list-item-action>

              <v-list-item-avatar
                v-if="task.type === AssignmentTaskType.MultipleChoicePicture"
                tile
                color="grey lighten-3"
                class="mr-4"
                @click.stop="previewImage(option.value)"
              >
                <v-img
                  :src="option.value"
                />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ getOptionItemValue(option) }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </div>
</template>

<script>
import { AssignmentTaskType, AssignmentTaskTitle } from '@/helpers/assignments/configs';

export default {
  name: 'AssignmentTask',
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    answer: {
      type: Array,
      default: () => [],
    },
    achievedPoints: {
      type: Number,
      default: 0,
    },
    report: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      AssignmentTaskType,
      AssignmentTaskTitle,
    };
  },
  computed: {
    specifiedAnswer: {
      get() {
        const { answer } = this;
        const answersIdx = (answer || [answer])
          .map(id => this.task.options?.findIndex(o => o.id === id));

        switch (this.task.type) {
          case AssignmentTaskType.MultipleChoice: return answersIdx[0];
          case AssignmentTaskType.FillInTheBlanks: return answer[0] ?? '';
          case AssignmentTaskType.TrueOrFalse: return answersIdx[0];
          case AssignmentTaskType.MultipleChoicePicture: return answersIdx;
          case AssignmentTaskType.MultiSelectText: return answersIdx;
          default: return [];
        }
      },
      set(value) {
        const answerArray = Array.isArray(value) ? value : [value];
        const answer = answerArray
          .map(answerIdx => this.task.options?.[answerIdx]?.id || answerIdx);
        this.$emit('update:answer', answer);
      },
    },
    multipleAnswers() {
      const multiSelectTypes = [
        AssignmentTaskType.MultipleChoicePicture,
        AssignmentTaskType.MultiSelectText,
      ];
      return multiSelectTypes.includes(this.task.type);
    },
    taskPoints() {
      if (this.report) {
        return `${this.achievedPoints || 0}/${this.task.points}`;
      }
      return this.task.points;
    },
  },
  methods: {
    getOptionItemValue(option) {
      return this.task.type === AssignmentTaskType.MultipleChoicePicture ? option.id : option.value;
    },
    previewImage(src) {
      this.$emit('image-preview', src);
    },
  },
};
</script>

<style lang="scss" scoped>
.assignment-task {
  &__question {
    background-color: #E8E8E8;
    border: 2px solid #b0b0b0;
    border-radius: 16px;
    margin: 24px 16px;
  }
}
</style>
